import { Avatar, Grid, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { BlueExcMark } from 'Images';
interface IInfoText {
  text: string;
  icon?: string;
}
export const InfoText = (props: IInfoText) => {
  const isDesktop = useIsDesktop();

  return (
    <Grid container columnGap={1} sx={{ flexWrap: 'unset' }}>
      <Avatar
        src={props.icon || BlueExcMark}
        alt=''
        sx={
          isDesktop
            ? {
                width: '20px',
                height: '20px',
                mt: '2px',
              }
            : {
                width: '16px',
                height: '16px',
                mt: '4px',
              }
        }
      />
      <Typography color='#4d4d4d' component={'p'}>
        {props.text}
      </Typography>
    </Grid>
  );
};
